import { format, isValid, parseISO } from 'date-fns';
import { ComponentProps } from 'react';
import theme from 'App.theme';
import { Delivery } from 'api/models/Deliveries';
import Dialog from 'components/Dialog';
import SavingPleaseWaitDialog from 'components/SavingPleaseWaitDialog';
import en from 'locale/en';

type Props = ComponentProps<typeof Dialog> & {
  // the turnaround destination delivery whose surgery the equipment was added to
  delivery?: Delivery;
  // true while the destination delivery is still being fetched
  loading?: boolean;
};

export const TurnaroundSuccessDialog = ({ delivery, loading, ...props }: Props) => {
  const surgeryDate = delivery?.surgery?.surgeryDate;
  const parsedSurgeryDate = typeof surgeryDate === 'string' ? parseISO(surgeryDate) : surgeryDate;

  // Format the surgery date
  const formattedSurgeryDate =
    parsedSurgeryDate && isValid(parsedSurgeryDate) ? format(parsedSurgeryDate, 'dd/MM/yyyy hh:mm a') : 'Unknown Date';

  // Replace placeholders in the title string
  const title = en.TurnaroundSuccessDialog.title
    .replace('[Surgery ID]', delivery?.surgery?.surgeryReference || 'Unknown Surgery ID')
    .replace('[Surgery Date]', formattedSurgeryDate)
    .replace('[Surgeon]', delivery?.surgery?.surgeonName || 'Unknown Surgeon');

  if (loading) {
    return <SavingPleaseWaitDialog reason="loading" />;
  }

  return (
    <Dialog
      title={title}
      actionsSx={{
        flexDirection: 'column-reverse',
        alignItems: 'stretch',
        gap: theme.layout.spacing.small,
        ['& > button:not(style)']: {
          marginLeft: 0,
        },
      }}
      {...props}
    />
  );
};
